<template>
  <div class="card card-performance-objective">
    <div class="card-header">
      <div class="row no-gutters">
        <div class="col d-flex align-items-center">
          <textarea
            class="form-control auto-height"
            v-auto-height
            placeholder="Performance objective...."
            rows="1"
            name="description"
            :data-vv-scope="`objectives.${objectiveIndex}`"
            v-model.lazy="stateDescription"
            v-validate.disable="'required'"
          ></textarea>
        </div>
        <div class="col-auto d-flex align-items-center">
          <button type="button" class="btn btn-link text-danger btn-delete-performance-objective" @click="confirmBeforeDeleting">
            <font-awesome :icon="['far', 'trash-alt']" fixed-width/>

            <span class="sr-only">Delete Performance Objective</span>
          </button>
        </div>
      </div><!-- /.row -->
    </div>
    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p>
              Key Milestones.
              <span class="minor">Minimum of 2.</span>
            </p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Start Date</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>End Date</p>
          </div>
        </div><!-- /.row -->
      </li>
      <placements-start-component-performance-item-milestone
        v-for="(milestone, milestoneIndex) in milestones"
        :key="`objective-${objectiveIndex}-milestone-${milestoneIndex}`"
        :objective-index="objectiveIndex"
        :milestone-index="milestoneIndex"
        :milestone="milestone"
        :is-last-milestone="milestoneIndex === milestones.length - 1"
      />
    </ul>
  </div><!-- /.card -->
</template>

<script>
import { alert } from 'utils'
import { placementPerformanceObjectiveMethods } from 'vx/helpers'
import PlacementsStartComponentPerformanceItemMilestone from './PlacementsStartComponentPerformanceItemMilestone'

export default {
  inject: ['$validator'],

  props: {
    objectiveIndex: {
      required: true,
      type: Number
    },
    objective: {
      required: true,
      type: Object
    }
  },

  components: {
    PlacementsStartComponentPerformanceItemMilestone
  },

  computed: {
    stateDescription: {
      get () {
        return this.objective.description
      },

      set (value) {
        this.setObjectiveProperty({
          objectiveIndex: this.objectiveIndex,
          property: 'description',
          value
        })
      }
    },

    milestones () {
      return this.objective.milestones
    }
  },

  watch: {
    milestones: {
      handler () {
        if (this.milestones.length === 0) {
          this.addBlankMilestone(this.objectiveIndex)
        } else {
          let milestone = this.milestones[this.milestones.length - 1]

          if (
            (milestone.description !== null && milestone.description !== '') ||
            (milestone.start_date !== null && milestone.start_date !== '') ||
            (milestone.end_date !== null && milestone.end_date !== '')
          ) {
            this.addBlankMilestone(this.objectiveIndex)
          }
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...placementPerformanceObjectiveMethods,

    async confirmBeforeDeleting () {
      if (
        !await alert.confirm({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete this performance objective and any key milestones.'
        })
      ) {
        return
      }

      this.deleteObjective(this.objectiveIndex)
    }
  }
}
</script>
